module.exports = __webpack_public_path__ + "assets/img/media_7.9d2c7be0.png";